'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';
import { useAuthedQuery } from './useAuthedQuery';
import { useProfileUpdater } from './useProfileQueries';

const TICK_INTERVAL_MS = 60_000;

export function useChickenTick(enabled = true) {
  const apiClient = useApiClient();

  return useAuthedQuery({
    queryKey: queryKeys.chickenTick,
    queryFn: () => apiClient.api.chickenRewardControllerTickChickenSpawn(),
    enabled,
    staleTime: 0,
    refetchInterval: TICK_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
}

export function useClaimChicken() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const { updateBalance } = useProfileUpdater();

  return useMutation({
    mutationFn: (spawnId: string) =>
      apiClient.api.chickenRewardControllerClaimChickenReward({ spawnId }),
    onSuccess: (result) => {
      updateBalance(result.newBalance);
      queryClient.invalidateQueries({ queryKey: queryKeys.chickenTick });
      queryClient.invalidateQueries({ queryKey: queryKeys.profile });
    },
  });
}
